<template>
  <div>
    <div class="footer">
      <div class="wrapper">
        <div class="friendLink">
          <div style="width:90px;font-weight:700;margin-right:8px;">友情链接：</div>
          <div>
            <div><a href="http://www.moe.gov.cn/" target="_blank">中华人民共和国教育部</a></div>
            <div><a href="https://www.mca.gov.cn/"  target="_blank">中华人民共和国民政部</a></div>
          </div>
          <div>
            <div><a href="http://www.mof.gov.cn/index.htm"  target="_blank">中华人民共和国财政部</a></div>
            <div><a href="https://chinanpo.mca.gov.cn/"  target="_blank">中国社会组织网</a></div>
          </div>
          <div>
            <div><a href="https://www.chsi.com.cn/"  target="_blank">中国高等教育学生信息网
            </a></div>
            <div><a href="https://www.xszz.edu.cn/"  target="_blank">全国学生资助管理中心网</a></div>
          </div>
          <div>
            <div><a href="https://www.cscse.edu.cn/"  target="_blank">中国留学网</a></div>
          </div>
          <div>
            <div><a href="http://www.10086.cn/index/bj/index_100_100.html" target="_blank">中国移动通信网</a></div>
          </div>
        </div>
        <div class="address">
          <span>版权所有：中国教育发展基金会</span>
          <span>地址：北京市西城区西单大木仓胡同35号</span>
          <span>邮编：100816</span>
        </div>
        <div class="relation">
          <span>电话：010-66097788</span>
          <span style="color: black">传真：010-66097755</span>
        </div>
        <web-icp />
        <div class="QR-code">
          <div>
            <span> <img src="@/assets/homeImg/GwQR.png" alt="" class="QR-code-img"></span>
            <span>微信公众号</span>
          </div>
          <div>
            <span> <img src="@/assets/homeImg/GwQR.png" alt="" class="QR-code-img"></span>
            <span>微信公众号</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WebIcp from '@/components/webIcp'

export default {
  components: { WebIcp }
}
</script>

<style lang="scss" scoped>
.QR-code-img {
  width: 72px;
  height: 72px;
}
.footer {
  // position: relative;
  height: 268px;
  background-color: #f7f8fa;
  .wrapper {
    position: relative;
    height: 100%;
    font-size: 16px;
    color: #1d2129;
    padding: 40px 0 0 72px;
    .friendLink {
      display: flex;
      div {
        width: 220px;
        font-weight: 400;
      }
      div:nth-child(1) {
        margin-bottom: 16px;
      }
    }
    .address {
      span {
        display: inline-block;
        margin: 40px 110px 0 0;
        font-size: 14px;
      }
    }
    .relation {
      span {
        display: inline-block;
        margin: 16px 40px 0 0;
        font-size: 14px;
      }
      span:nth-child(3) {
        color: #020d4d;
      }
    }
  }
}
.QR-code {
  position: absolute;
  right: 72px;
  top: 140px; //
  display: flex;
  div {
    margin-left: 48px;
    span:nth-child(1) {
      display: block;
      width: 72px;
      height: 72px;
      background: black;
      margin-bottom: 8px;
    }
    span:nth-child(2) {
      font-size: 14px;
      color: #1d2129;
      padding: 0 1px;
    }
  }
}
.friendLink-title {
  width: 80px;
  font-weight: 700;
  margin-right: 8px;
}
</style>
